export enum HQUserStatus {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  PENDING = 'pending',
  DELETED = 'deleted',
  NOT_INVITED = 'not_invited',
}
